import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {Component, inject} from '@angular/core';
import {filter, map} from 'rxjs/operators';

// import {SEOService} from './services/SEO.service';

@Component({
    selector: 'kkm-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent {
    // private seo = inject(SEOService);

    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);

    ngOnInit(): void {
        // this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        //     var rt = this.getChild(this.activatedRoute);
        //     rt.data.subscribe(data => {
        //         // console.log(data);
        //         this.seo.updateRouteMetadata(data);
        //     });
        // });
    }

    getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }
}
